<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-6 col-sm-1">
              <v-text-field label="Nome" v-model="current.name" outlined dense></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field label="Usuário" v-model="current.username" outlined dense></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Senha"
                v-model="current.password"
                type="password"
                outlined
                dense
                readonly
                append-icon="mdi-lock-reset"
                @click:append="dialog_password = true;"
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-sm-1">
              <v-select
                label="Status"
                v-model="current.enabled"
                :items="enabled"
                outlined
                dense
              ></v-select>
            </div>
            <div class="col-md-6 col-sm-1">
              <v-select label="Função" v-model="current.role" :items="role" outlined dense></v-select>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialog_password" max-width="600px">
      <v-card>
        <v-card-title>Configurar senha</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Senha"
              v-model="new_password"
              type="password"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              label="Repetir Nova Senha"
              v-model="new_password2"
              type="password"
              outlined
              dense
            ></v-text-field>
            <v-alert dense type="warning">Para efetivar, clique em Salvar na tela abaixo!</v-alert>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="changePassword()">OK</v-btn>
          <v-btn color="default" @click="dialog_password = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    enabled: [
      { text: "Ativado", value: true },
      { text: "Desativado", value: false }
    ],
    role: [
      { text: "Administrador", value: 0 },
      { text: "Usuário", value: 128 }
    ],
    new_password: '',
    new_password2: '',
    dialog_password: false
  }),
  created: function() {
    this.load();
  },
  methods: {
    load: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/user" + "/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token }
        })
        .then(function(response) {
          me.current = response.data;
        })
        .catch(function() {
          console.log("user fail");
          alert("Falha ao recuperar dados do usuário!");
        });
    },
    save: function() {
      var token = localStorage.getItem("token");
      if (this.current.id == 0) {
        if(this.current.secret===""){
          alert("A senha não pode ser vazia!");
          return;
        }
        api
          .post("/user", this.current, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(function() {
            alert("Usuário cadastrado com sucesso!");
            router.push({ path: "/user" });
          })
          .catch(function(){
            alert("Falha ao cadastrar usuário!");
          });
      } else {
        api
          .put("/user/" + this.current.id, this.current, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(function() {
            alert("Usuário atualizado com sucesso!");
            router.push({ path: "/user" });
          })
          .catch(function(){
            alert("Falha ao atualizar usuário!");
          });
      }
    },
    changePassword: function(){
      if(this.new_password===this.new_password2){
        this.current.secret = this.new_password;
        this.dialog_password = false;
      }else{
        alert("Senhas diferentes!");
      }
    }
  }
};
</script>